import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { NewNodalOfficerDashboardLotterywiseModel } from "src/app/model/NewNodalOfficerDashboardLotterywiseModel";
import { DashboardService } from "src/app/services/dashboard.service";
import { IgxLegendComponent, IgxCategoryChartComponent } from 'igniteui-angular-charts';
import { ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { timeSpanDays } from "igniteui-angular-core";
import { ImportMasterService } from "src/app/services/import-master.service";
import { ActivatedRoute, Params } from "@angular/router";
import * as XLSX from 'xlsx';




@Component({
  selector: "new-dashboard",
  templateUrl: "./new-dashboard-lotterywise.component.html",
  styleUrls: ["./new-dashboard.component.scss","./external.component.scss"],
})
export class NewDashboardLotteryWiseComponent implements OnInit {
  userName: string;
  nodalOfficerDashboardModel: NewNodalOfficerDashboardLotterywiseModel;
  loaded: boolean = false;
  date: Date;
  nocPendingCount:number;
  @ViewChild("legend", { static: true } )
  private legend: IgxLegendComponent
  @ViewChild("chart", { static: true } )
  private chart: IgxCategoryChartComponent
  totalten: number ;
  totalaccep: number;
  totaleligble: number;
  totalsurrendered: number;
  pol: number;
  allotment: number;
  possession: number;
  tenpaid: number;
  ninthpaid: number;
  eightpaid: number;
  sevenpaid: number;
  sixpaid: number;
  fifthpaid: number;
  fourthpaid: number;
  thirdpaid: number;
  secondpaid: number;
  firstpaid: number;
  successMessage: string;
  errorMessage: String;
  lotterycode: String;
  isSubmitDisabled: boolean = false;
  lotteryKey:number;
  schemeKey:number;


  lotetryFilter: FormGroup = new FormGroup({});
  lotteries: {[key: number]: string};
  schemes: {[key: number]: string};
  filterForm: FormGroup = new FormGroup({});
  form: FormGroup = new FormGroup({});
  chartOptions;
  chartOptions1: any;
  displayedColumns: string[] = [
    "key",
    "lottery",
    "actionTime",
    "status",
  ];

  constructor(private router: Router, private route: ActivatedRoute, 
    private dashboardService: DashboardService, private importMasterService: ImportMasterService,
    private modalCtrl: ModalController) { }
    
  ngOnInit(): void { 
    
    this.filterForm = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(2),
      ]),
      lotetryFilter: new FormControl()
     
    });
//this.mumbaiPaid=this.nodalOfficerDashboardModel.mumbaiPaid
    this.loadData();
  //  this.noSelection();
    
  }

  refresh() {
    this.ngOnInit();
  }
  loadData() {
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    this.route.params.subscribe((params: Params) => {
    this.lotteryKey = +params['lotteryKey'];
    
      console.log(roles,"from rolls");
      this.dashboardService.fetchLotteryWiseDashboard(
        this.lotteryKey
      ).subscribe(dashboard => {
        this.nodalOfficerDashboardModel = dashboard;
        
        this.date = new Date();
        this.totalten=dashboard.totalten;
        this.totalaccep=dashboard.totalaccep;
        this.totaleligble=dashboard.totaleligble;
        this.lotterycode=dashboard.lotterycode;
        this.totalsurrendered=dashboard.totalsurrendered;
        this.pol=dashboard.pol;
        this.allotment=dashboard.allotment;
        this.possession=dashboard.possession;
        this.firstpaid=dashboard.firstpaid;
        this.secondpaid=dashboard.secondpaid;
        this.thirdpaid=dashboard.thirdpaid;
        this.fourthpaid=dashboard.fourthpaid;
        this.schemes=dashboard.schemes;
        console.log(this.schemes,"schemes");
        // console.log(this.totalten,"totaltenement");
        this.lotteries = dashboard.lotteries;
        console.log(this.lotteries,"lotteries");
        console.log(this.lotteryKey,"lotteryKey");
        this.loaded = true;

        this.chartOptions = {
    
          animationEnabled: true,
          exportEnabled: true,
          title: {
          text: "Lottery-Wise All Application Details"
          },
          axisX: {
          labelAngle: 180
          },
          axisY: {
          title: "No Of Applications"
          },
          toolTip: {
          shared: true
          },
          legend:{
          cursor:"pointer",
          itemclick: function(e: any){
            if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
            }
            else {
            e.dataSeries.visible = true;
            }
            e.chart.render();
          }
          },
          data: [{
          type: "column",	
          name: "Total Tenement",
          legendText: "Total Tenement",
          showInLegend: true, 
          dataPoints:[
            {label: this.lotterycode, y: this.totalten}
          ]
          }, {
          type: "column",	
          name: "Application Accepted Tenement",
          legendText: "Application Accepted Tenement",
          // axisYType: "secondary",
          showInLegend: true,
          dataPoints:[
            {label: this.lotterycode, y: this.totalaccep}
          ]
          },{
            type: "column",	
            name: "Eligble Application",
            legendText: "Eligble Application",
            // axisYType: "secondary",
            showInLegend: true,
            dataPoints:[
              {label: this.lotterycode, y: this.totaleligble}
            ]
            },{
              type: "column",	
              name: " Surrendered Application",
              legendText: " Surrendered Application",
              // axisYType: "secondary",
              showInLegend: true,
              dataPoints:[
                {label: this.lotterycode, y: this.totalsurrendered}
              ]
              },{
                type: "column",	
                name: "Pol Published",
                legendText: "Pol Published",
                // axisYType: "secondary",
                showInLegend: true,
                dataPoints:[
                  {label: this.lotterycode, y: this.pol}
                ]
                },{
                  type: "column",	
                  name: "Allotment",
                  legendText: "Allotment",
                  // axisYType: "secondary",
                  showInLegend: true,
                  dataPoints:[
                    {label: this.lotterycode, y: this.allotment}
                  ]
                  },{
                    type: "column",	
                    name: "POSSESSION",
                    legendText: "POSSESSION",
                    // axisYType: "secondary",
                    showInLegend: true,
                    dataPoints:[
                      {label: this.lotterycode, y: this.possession}
                    ]
                    }
        
        ]
        }	
      //   this.chartOptions1 = {
      //     animationEnabled: true,
      //  //   theme: "dark2",
      //     title: {
      //     text: "Installment Payment by Applicant"
      //     },
      //     data: [{
      //     type: "column",
      //     startAngle: -90,
      //     indexLabel: "{name}: {y}",
      //     yValueFormatString: "#,###.##",
      //     dataPoints: [
      //       { y: this.firstpaid, name: "1stInstallment" },
      //       { y: this.secondpaid, name: "2ndInstalllment" },
      //       { y: this.thirdpaid, name: "3rdInstalllment" },
      //       { y: this.fourthpaid, name: "4thInstalllment" }
      //       // { y: 0, name: "5thInstalllment" },
      //       // { y: 0, name: "6thInstalllment" },
      //       // { y: 0, name: "7thInstalllment" },
      //       // { y: 0, name: "8thInstalllment" },
      //       // { y: 0, name: "9thInstalllment" },
      //       // { y: 0, name: "10thInstalllment" }
            
      //     ]
      //     }]
      //   }	
      this.chartOptions1 = {
    
        animationEnabled: true,
        exportEnabled: true,

        title: {
        text: "Installment Payment by Applicant"
        },
        axisX: {
        labelAngle: 180
        },
        axisY: {
        title: "No Of Paid Applications"
        },
        toolTip: {
        shared: true
        },
        legend:{
        cursor:"pointer",
        itemclick: function(e: any){
          if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
          e.dataSeries.visible = false;
          }
          else {
          e.dataSeries.visible = true;
          }
          e.chart.render();
        }
        },
        data: [{
        type: "column",	
        name: "1st Installment",
        legendText: "1st Installment",
        showInLegend: true, 
        dataPoints:[
          {label: this.lotterycode, y: this.firstpaid}
        ]
        }, {
        type: "column",	
        name: "2nd Installment",
        legendText: "2nd Installment",
        // axisYType: "secondary",
        showInLegend: true,
        dataPoints:[
          {label: this.lotterycode, y: this.secondpaid}
        ]
        },{
            type: "column",	
            name: "3rd Installment",
            legendText: "3rd Installment",
            // axisYType: "secondary",
            showInLegend: true,
            dataPoints:[
              {label: this.lotterycode, y: this.thirdpaid}
            ]
            },{
              type: "column",	
              name: "4th Installment",
              legendText: "4th Installment",
              // axisYType: "secondary",
              showInLegend: true,
              dataPoints:[
                {label: this.lotterycode, y: this.fourthpaid}
              ]
              }
      
      ]}
      
        
      });

    });   
  }

 
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.chartOptions);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'DataSheet');
    XLSX.writeFile(wb, 'chart_data.xlsx');
  }
  
  
  onChangeSchemeFilter(value) {
    console.log(value);
    this.schemeKey=value.key;
    console.log(this.schemeKey);
  }
 

  schemeWiseData() {
    if (this.schemeKey){
      console.log(this.filterForm.value.schemeKey,"Data");

    }
    else {
           this.errorMessage;
           this.dashboardService.errorToast("Please select Scheme And push the back button to return to origional page");
           this.isSubmitDisabled=false;
           this.loaded=true;
         }

   }

  //  noSelection() {
  //   if (this.lotteryKey){
  //     console.log(this.filterForm.value.lotteryKey,"Data");

  //   }
  //   else {
  //          this.loaded=true;
  //        }

  //  }
}